import { render, staticRenderFns } from "./MainCreditInfomationTab.vue?vue&type=template&id=1424f9b8&"
import script from "./MainCreditInfomationTab.vue?vue&type=script&lang=ts&"
export * from "./MainCreditInfomationTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports